/**
 * User preferences persisted in localStorage.
 *
 * Keys:
 * tt:sidebarPanel — sidebar background panel ID
 * tt:mode —"day" | "night"* tt:landingPage —"home" | "projects" | "reports"*/

export type SidebarPanel = "dark" | "light" | "red" | "gradient" | "image";
export type AppMode = "day" | "night";
export type LandingPage = "home" | "projects" | "reports";

const PANEL_KEY ="tt:sidebarPanel";
const MODE_KEY ="tt:mode";
const LANDING_KEY ="tt:landingPage";

/* ── Sidebar Panel ── */

export function getSidebarPanel(): SidebarPanel {
 if (typeof window ==="undefined") return"gradient";
 const v = window.localStorage.getItem(PANEL_KEY);
 if (v ==="dark"|| v ==="light"|| v ==="red"|| v ==="gradient"|| v ==="image") return v;
 return"gradient";
}

export function setSidebarPanel(panel: SidebarPanel): void {
 if (typeof window ==="undefined") return;
 window.localStorage.setItem(PANEL_KEY, panel);
 window.dispatchEvent(new Event("tt:settings-changed"));
}

/* ── Mode (Day / Night) ── */

export function getAppMode(): AppMode {
 if (typeof window ==="undefined") return"day";
 const v = window.localStorage.getItem(MODE_KEY);
 if (v ==="day"|| v ==="night") return v;
 return"day";
}

export function setAppMode(mode: AppMode): void {
 if (typeof window ==="undefined") return;
 window.localStorage.setItem(MODE_KEY, mode);
 applyMode(mode);
 window.dispatchEvent(new Event("tt:settings-changed"));
}

/** Apply light mode — dark mode is disabled. */
export function applyMode(_mode?: AppMode): void {
 if (typeof window ==="undefined") return;
 document.documentElement.classList.remove("dark");
}

/* ── Landing Page ── */

export function getLandingPage(): LandingPage {
 if (typeof window ==="undefined") return"home";
 const v = window.localStorage.getItem(LANDING_KEY);
 if (v ==="home"|| v ==="projects"|| v ==="reports") return v;
 return"home";
}

export function setLandingPage(page: LandingPage): void {
 if (typeof window ==="undefined") return;
 window.localStorage.setItem(LANDING_KEY, page);
 window.dispatchEvent(new Event("tt:settings-changed"));
}

/** Convert landing page preference to a route path. */
export function landingPageToPath(page?: LandingPage, userId?: number | string): string {
 const p = page ?? getLandingPage();
 const id = userId ??"";
 if (p ==="projects") return id ?`/employees/${id}/projects`:"/dashboard";
 if (p ==="reports") return id ?`/employees/${id}/work-calendar`:"/dashboard";
 return"/dashboard";
}
